export const packageList = [
  {
    name: 'iaa',
    activeRule: ['iaa'],
  },
]

export const remoteModuleConfig = {
  dev: ['iaa'],
  stg: ['iaa'],
  uat: ['iaa'],
  prd: ['iaa'],
}




// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/iaa/index.js